import React, { useEffect, Suspense, lazy, createElement } from 'react';
const SocialProof = lazy(() => import('./components/SocialProof').then(m => ({
  default: m.SocialProof
})));
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const ProductShowcase = lazy(() => import('./components/ProductShowcase').then(m => ({
  default: m.ProductShowcase
})));
const WhatYouGet = lazy(() => import('./components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Countdown = lazy(() => import('./components/Countdown').then(m => ({
  default: m.Countdown
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const ProBusiness = lazy(() => import('./components/ProBusiness').then(m => ({
  default: m.ProBusiness
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const DarkCTA = lazy(() => import('./components/DarkCTA').then(m => ({
  default: m.DarkCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchaseNotifications = lazy(() => import('./components/PurchaseNotifications').then(m => ({
  default: m.PurchaseNotifications
})));
const HERO_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_400/v1777593352/hf_20260430_234428_41cb3c68-981e-4c20-8031-afe469b66fa3-Photoroom_djwf2s.webp';
const OG_IMG = 'https://cdn.magicpatterns.com/uploads/9uMhQHg3RXXbKPqANDF9n5/hf_20260423_164447_343907b5-95aa-49ff-ba71-eeea9d0be6f6-Photoroom.webp';
export function App() {
  useEffect(() => {
    const runSeo = () => {
      document.title = 'Megapack Kinesiología Resuelta — Consulta Resuelta™';
      document.documentElement.lang = 'es';
      const setMeta = (name: string, content: string, property?: boolean) => {
        const attr = property ? 'property' : 'name';
        let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement;
        if (!el) {
          el = document.createElement('meta');
          el.setAttribute(attr, name);
          document.head.appendChild(el);
        }
        el.content = content;
      };
      const description = 'Sistema clínico completo para kinesiólogos. 6 Tomos, protocolos listos para usar, evaluación clínica, traumatología, neurociencia del dolor, gestión de carrera y 6 bonos profesionales. Todo tu año de consultorio resuelto. Acceso inmediato.';
      const url = 'https://kinesiologiaresuelta.com';
      const image = OG_IMG;
      setMeta('description', description);
      setMeta('keywords', 'kinesiología resuelta, megapack kinesiólogos, protocolos kinésicos listos, primera consulta kinesiología, sistema clínico kinesiología, Argentina, consulta resuelta, kinesiólogos argentina, evaluación clínica, traumatología y ortopedia');
      setMeta('robots', 'index, follow');
      setMeta('author', 'Consulta Resuelta™');
      setMeta('viewport', 'width=device-width, initial-scale=1');
      if (!document.querySelector('link[rel="canonical"]')) {
        const canonical = document.createElement('link');
        canonical.rel = 'canonical';
        canonical.href = url;
        document.head.appendChild(canonical);
      }
      setMeta('og:title', 'Megapack Kinesiología Resuelta — Todo tu año de consultorio resuelto', true);
      setMeta('og:description', description, true);
      setMeta('og:image', image, true);
      setMeta('og:url', url, true);
      setMeta('og:type', 'product', true);
      setMeta('og:locale', 'es_AR', true);
      setMeta('og:site_name', 'Consulta Resuelta™', true);
      setMeta('twitter:card', 'summary_large_image');
      setMeta('twitter:title', 'Megapack Kinesiología Resuelta — Consulta Resuelta™');
      setMeta('twitter:description', description);
      setMeta('twitter:image', image);
      if (!document.querySelector('script[data-ld="product"]')) {
        const ld = document.createElement('script');
        ld.type = 'application/ld+json';
        ld.setAttribute('data-ld', 'product');
        ld.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Product',
          name: 'Megapack Kinesiología Resuelta — Sistema Clínico Completo™',
          description,
          image,
          brand: {
            '@type': 'Brand',
            name: 'Consulta Resuelta™'
          },
          offers: {
            '@type': 'AggregateOffer',
            lowPrice: '19990',
            highPrice: '27990',
            priceCurrency: 'ARS',
            availability: 'https://schema.org/InStock',
            offerCount: 2
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '4.9',
            reviewCount: '487'
          }
        });
        document.head.appendChild(ld);
      }
      if (!document.querySelector('script[data-ld="org"]')) {
        const orgLd = document.createElement('script');
        orgLd.type = 'application/ld+json';
        orgLd.setAttribute('data-ld', 'org');
        orgLd.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Consulta Resuelta™',
          url,
          logo: image,
          email: 'hola@kinesiologiaresuelta.com',
          sameAs: ['https://www.instagram.com/kinesiologiaresuelta']
        });
        document.head.appendChild(orgLd);
      }
      if (!document.querySelector('script[data-ld="faq"]')) {
        const faqLd = document.createElement('script');
        faqLd.type = 'application/ld+json';
        faqLd.setAttribute('data-ld', 'faq');
        faqLd.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: [{
            '@type': 'Question',
            name: '¿Qué incluye el Megapack Kinesiología Resuelta?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '6 Tomos completos con sistema de evaluación clínica, protocolos de traumatología y ortopedia, abordaje domiciliario, neurociencia del dolor, gestión legal y gestión de carrera profesional. Incluye además 6 bonos profesionales con scripts de WhatsApp, protocolo de sesión premium, guía de redes sociales y más.'
            }
          }, {
            '@type': 'Question',
            name: '¿Cómo recibo el material?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Todo es 100% digital en formato PDF. Recibís acceso inmediato en tu email dentro de los 5 minutos posteriores a la compra.'
            }
          }, {
            '@type': 'Question',
            name: '¿Tiene garantía?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Sí, ofrecemos garantía de 7 días sin preguntas. Si no te sirve, te devolvemos el 100% de tu dinero.'
            }
          }, {
            '@type': 'Question',
            name: '¿Está adaptado a Argentina?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Sí, 100%. Los protocolos, documentación legal y sistemas de gestión están completamente adaptados al contexto clínico, legal y profesional argentino.'
            }
          }, {
            '@type': 'Question',
            name: '¿Para qué tipo de kinesiólogo es este sistema?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Para kinesiólogos que atienden en consultorio presencial, domiciliario u online, tanto recién graduados como con experiencia, que quieren ahorrar tiempo, trabajar con protocolos sólidos y escalar sus honorarios con criterio profesional.'
            }
          }, {
            '@type': 'Question',
            name: '¿Qué es el Método KINE-PRO?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Es el Upsell del Megapack. Un sistema maestro de razonamiento clínico avanzado, gestión operativa y alta rentabilidad para el kinesiólogo que quiere llevar su práctica al siguiente nivel. Disponible como upgrade por $29.950.'
            }
          }]
        });
        document.head.appendChild(faqLd);
      }
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(runSeo, {
        timeout: 1500
      });
    } else {
      setTimeout(runSeo, 100);
    }
  }, []);
  useEffect(() => {
    const loadFbPixel = () => {
      if (typeof window !== 'undefined' && !(window as any).fbq) {
        const f = window as any;
        const n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        (window as any).fbq('init', '1215304437119773');
        (window as any).fbq('track', 'PageView');
        const t = document.createElement('script');
        t.async = true;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const s = document.getElementsByTagName('script')[0];
        s?.parentNode?.insertBefore(t, s);
      }
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadFbPixel, {
        timeout: 5000
      });
    } else {
      setTimeout(loadFbPixel, 5000);
    }
  }, []);
  return <>
      <noscript data-id="element-0">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1215304437119773&ev=PageView&noscript=1" alt="" data-id="element-1" />
      </noscript>

      {/* ── HEADER / HERO ── */}
      <header className="relative flex w-full flex-col items-center justify-center text-center text-gray-900 text-base leading-6 px-5 sm:px-6 py-12 sm:py-16" role="banner" style={{
      fontFamily: 'var(--font-system)',
      backgroundImage: 'linear-gradient(180deg, rgb(224,247,255) 0%, rgb(186,235,255) 40%, rgb(210,243,255) 75%, rgb(235,248,255) 100%)',
      backgroundColor: 'rgb(224,247,255)'
    }} data-id="element-2">
        {/* ── 1. BADGE ── */}
        <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-cyan-600/30 bg-white/80 px-4 py-1.5 shadow-sm" data-id="element-3">
          <span className="text-xs sm:text-sm font-bold text-cyan-700 tracking-wide uppercase" data-id="element-4">
            🦴 Sistema Clínico Profesional · Kinesiólogos Argentina
          </span>
        </div>

        {/* ── 2. H1 ── */}
        <h1 className="font-black max-w-4xl text-gray-900 m-0 mb-2 tracking-tight text-[25px]" style={{
        lineHeight: '1.35'
      }} data-id="element-5">
          Dejá de llegar al consultorio sin saber qué hacer.
          <br data-id="element-6" />
          <span style={{
          color: '#0077B6'
        }} data-id="element-7">
            Tu práctica kinésica, RESUELTA.
          </span>
        </h1>

        {/* ── 3. MOCKUP (LCP element) ── */}
        <div className="my-6 sm:my-8 w-full max-w-[320px] sm:max-w-[380px] aspect-square relative" data-id="element-8">
          <div className="absolute inset-4 rounded-full z-0 pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(0,180,216,0.30) 0%, rgba(0,180,216,0.10) 50%, transparent 70%)'
        }} data-id="element-9" />
          <div className="relative z-10 w-full h-full" data-id="element-10">
            <img src={HERO_IMG} alt="Megapack Kinesiología Resuelta — Sistema Clínico Completo para Kinesiólogos" width="400" height="400" fetchPriority="high" decoding="sync" className="block max-w-full w-full h-auto object-contain" data-id="element-11" />
          </div>
        </div>

        {/* ── 4. SUBTÍTULO ── */}
        <p className="max-w-xl sm:text-lg font-semibold text-gray-700 m-0 mb-4 text-[15px]" data-id="element-12">
          El sistema que los kinesiólogos más organizados de Argentina usan para
          llegar preparados a cada sesión, documentar con autoridad y{' '}
          <span className="text-gray-900 font-black" data-id="element-13">
            cobrar lo que realmente vale su trabajo.
          </span>
        </p>

        {/* ── 5. TAGLINE MECANISMO ── */}
        <p className="max-w-xl text-lg sm:text-xl font-black m-0 mb-6" style={{
        color: '#0077B6'
      }} data-id="element-14">
          "Protocolos listos. Documentación blindada. Sin improvisar más, sin
          agotarte más."
        </p>

        {/* ── 6. TAGS ── */}
        <div className="mb-7 flex max-w-lg flex-wrap items-center justify-center gap-2" data-id="element-15">
          {['📄 100% PDF', '⚡ Acceso Inmediato', '🇦🇷 Argentina', '🦴 Kinesiología Clínica', '✅ Sistema Listo', '💼 6 Tomos + 6 Bonos'].map(tag => <span key={tag} className="whitespace-nowrap bg-white/80 text-xs sm:text-sm font-semibold text-gray-900 leading-5 rounded-full px-3 py-1 shadow-sm" style={{
          border: '1px solid rgba(0,119,182,0.30)'
        }} data-id="element-16">
              {tag}
            </span>)}
        </div>

        {/* ── 7. CTA BUTTON ── */}
        <a href="#pricing" onClick={() => {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'Lead', {
            content_name: 'Hero CTA Click',
            content_category: 'Kinesiología Resuelta'
          });
        }
      }} className="block w-full max-w-sm text-white text-lg sm:text-xl font-black rounded-xl px-6 sm:px-8 py-4 mb-4 no-underline text-center shadow-lg hover:opacity-90 transition-opacity" style={{
        backgroundColor: '#0077B6'
      }} data-id="element-17">
          🦴 → QUIERO MI MEGAPACK AHORA
        </a>

        {/* ── 8. TRUST BADGES ── */}
        <div className="flex flex-row flex-wrap items-center justify-center gap-3 sm:gap-4 m-0" data-id="element-18">
          <span className="inline-flex items-center gap-1.5 bg-white/80 border border-gray-200 rounded-full px-3 py-1.5 text-xs sm:text-sm text-gray-600 shadow-sm" data-id="element-19">
            🛡️ Garantía 7 días
          </span>
          <span className="inline-flex items-center gap-1.5 bg-white/80 border border-gray-200 rounded-full px-3 py-1.5 text-xs sm:text-sm text-gray-600 shadow-sm" data-id="element-20">
            🔒 Pago seguro
          </span>
          <span className="inline-flex items-center gap-1.5 bg-white/80 border border-gray-200 rounded-full px-3 py-1.5 text-xs sm:text-sm text-gray-600 shadow-sm" data-id="element-21">
            💳 Shopify | Tarjeta | Transferencia
          </span>
        </div>
      </header>

      {/* ── MAIN SECTIONS ── */}
      <main data-id="element-22">
        <Suspense fallback={null} data-id="element-23">
          <SocialProof data-id="element-24" />
        </Suspense>
        <Suspense fallback={null} data-id="element-25">
          <PainPoints data-id="element-26" />
          <ProductShowcase data-id="element-27" />
        </Suspense>
        <Suspense fallback={null} data-id="element-28">
          <WhatYouGet data-id="element-29" />
          <Bonuses data-id="element-30" />
          <Countdown data-id="element-31" />
          <Pricing data-id="element-32" />
          <ProBusiness data-id="element-33" />
          <Guarantee data-id="element-34" />
          <Testimonials data-id="element-35" />
          <FAQ data-id="element-36" />
          <DarkCTA data-id="element-37" />
        </Suspense>
      </main>

      {/* ── FOOTER ── */}
      <Suspense fallback={null} data-id="element-38">
        <Footer data-id="element-39" />
        <PurchaseNotifications data-id="element-40" />
      </Suspense>
    </>;
}